export default {
  product: {
    id: 'bo_seller.listings.listings_table.product_column',
    defaultMessage: 'Product',
  },
  inventory: {
    id: 'bo_seller.listings.listings_table.inventory_column',
    defaultMessage: 'Inventory',
  },
  markets: {
    id: 'bo_seller.listings.listings_table.markets_column',
    defaultMessage: 'Market(s)',
  },
  competition: {
    id: 'bo_seller.listings.listings_table.competition_column',
    defaultMessage: 'Competition',
  },
}
